<template>
  <div class="column is-12">
    <div class="card">
      <header class="header-card">
        <p>
          {{$t('societes.logistiqueImpression.produitDefaut.title')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-6">
            <b-field :label="$t('societes.logistiqueImpression.produitDefaut.visuel')">
              <b-select v-model="societe.produitIdDefautVisuel" expanded>
                <option v-for='produit in listeProduits(societe.produitIdDefautVisuel)'
                  :key="produit.id"
                  :value="produit.id">
                  {{ produit.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('societes.logistiqueImpression.produitDefaut.impression')">
              <b-select v-model="societe.produitIdDefautImpression" expanded>
                <option v-for='produit in listeProduits(societe.produitIdDefautImpression)'
                  :key="produit.id"
                  :value="produit.id">
                  {{ produit.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field :label="$t('societes.logistiqueImpression.produitDefaut.faconnage')">
              <b-select v-model="societe.produitIdDefautFaconnage" expanded>
                <option
                  v-for='produit in listeProduits(societe.produitIdDefautFaconnage)'
                  :key="produit.id"
                  :value="produit.id">
                  {{ produit.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field
              :label="$t('societes.logistiqueImpression.produitDefaut.impressionEtFaconnage')">
              <b-select v-model="societe.produitIdDefautImpressionEtFaconnage" expanded>
                <option v-for='produit in
                  listeProduits(societe.produitIdDefautImpressionEtFaconnage)'
                  :key="produit.id"
                  :value="produit.id">
                  {{ produit.libelle }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAll } from '@/api/produit/produitImpressionAffiche';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import messageErreur from '@/services/general/messageErreur';

export default {
  props: {
    societe: Object,
  },
  data() {
    return {
      produitsImpressionAffiche: [],
    };
  },
  methods: {
    listeProduits(id) {
      return this.produitsImpressionAffiche.filter((p) => {
        return p.actif || p.id === id;
      });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.produitsImpressionAffiche = (await getAll({
        query: {
          societeId: this.$route.params.id,
          actif: null,
        },
        orderBy: 'ProduitImpressionAffiche.Quantite, Libelle',
        ascending: true,
        maxResultCount: NO_PAGINATION,

      })).data.result.items;
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },

};
</script>

<style>

</style>
